import React, { Component } from "react";

export default class MedicalConsentHeader extends Component {
  render() {
    return (
      <React.Fragment>
        <h1 className="login-heading axa-headline">{this.props.pageTitle}</h1>
        {this.props.pageBody}
      </React.Fragment>
    );
  }
}
